import showToast from "../Helpers/toast";
export const TYPEFOROPTIONS = ["Dropdown", "Radio", "Checkbox"];

const getQuestionParams = (payload) => {
  const params = {};
  params.question = payload.question;
  params.sectionId = payload?.sectionId;
  params.type = payload.type;
  params.required = payload.required === "yes";
  if (payload.remarks) params.remarks = payload.remarks;
  if (payload.icon) params.icon = payload.icon;

  if (payload.type === "Calculate") {
    params.calculated = true;
    params.formula = payload.formula;
  } else if (TYPEFOROPTIONS.includes(payload.type)) {
    params.questionOptions = payload?.questionOptions.map((option) => ({
      name: option?.name,
      order: option?.order,
    }));

    delete params.calculated;
  }

  if (payload.skip === "yes") {
    params.skipLogic = payload.skipLogic;
  }
  params.order = payload.order;

  return params;
};

const validateQuestionParams = (payload) => {
  if (!payload.question || payload.question.trim().length < 1) {
    throw new Error("Question field cannot be empty");
  }

  if (!payload.type) {
    throw new Error("Select one response type");
  }

  if (
    TYPEFOROPTIONS.includes(payload.type) &&
    (!payload.questionOptions || payload.questionOptions?.length < 1)
  ) {
    throw new Error("No option added for type " + payload.type);
  }

  if (
    payload.type === "Calculate" &&
    (!payload.formula || payload.formula.trim().length < 1)
  ) {
    throw new Error("Enter formula for calculate type");
  }

  return true;
};

export const addQuestionnaireTitle = async (
  request,
  payload,
  module_type = "kii"
) => {
  const response = await request(
    "POST",
    `/v1/${module_type}/questionnaires`,
    {
      data: payload,
    },
    module_type == "kii" ? "kii_service" : "survey_service"
  );
  showToast({
    message: "New Questionnaire Created",
  });
  return response;
};

export const updateQuestionnaireTitle = async (
  request,
  payload,
  module_type = "kii"
) => {
  const response = await request(
    "PUT",
    `/v1/${module_type}/questionnaires`,
    {
      data: payload,
    },
    module_type == "kii" ? "kii_service" : "survey_service"
  );
  showToast({
    message: "Title Update Successful",
  });
  return response;
};

export const copyFromTemplate = async (
  request,
  payload,
  module_type = "kii"
) => {
  const response = await request(
    "POST",
    `/v1/${module_type}/questionnaires/template/copy`,
    {
      data: payload,
    },
    module_type == "kii" ? "kii_service" : "survey_service"
  );

  return response;
};

export const addQuestion = async (request, payload, module_type = "kii") => {
  validateQuestionParams(payload);
  const questionParams = getQuestionParams(payload);
  const response = await request(
    "POST",
    `/v1/${module_type}/questions`,
    { data: questionParams },
    module_type == "kii" ? "kii_service" : "survey_service"
  );
  return response;
};

export const updateQuestion = async (request, payload, module_type = "kii") => {
  validateQuestionParams(payload);
  const questionParams = {
    ...getQuestionParams(payload),
    questionId: payload.questionId,
  };
  const response = await request(
    "PUT",
    `/v1/${module_type}/questions`,
    { data: questionParams },
    module_type == "kii" ? "kii_service" : "survey_service"
  );

  return response;
};

export const deleteQuestion = async (
  request,
  question_id,
  module_type = "kii"
) => {
  const response = await request(
    "DELETE",
    `/v1/${module_type}/questions/${question_id}`,
    {},
    module_type == "kii" ? "kii_service" : "survey_service"
  );
  return response;
};

export const changeQuestionOrder = async (
  request,
  payload,
  module_type = "kii"
) => {
  const modified_payload = { ...payload };
  if (!payload.sectionId || payload.sectionId < 0) {
    delete modified_payload.sectionId;
  }
  const response = await request(
    "PUT",
    `/v1/${module_type}/questions/order`,
    {
      data: modified_payload,
    },
    module_type == "kii" ? "kii_service" : "survey_service"
  );

  return response;
};

export const addSection = async (request, payload, module_type = "kii") => {
  const response = await request(
    "POST",
    `/v1/${module_type}/sections`,
    { data: payload },
    module_type == "kii" ? "kii_service" : "survey_service"
  );
  return response;
};

export const updateSection = async (request, payload, module_type = "kii") => {
  const response = await request(
    "PUT",
    `/v1/${module_type}/sections`,
    { data: payload },
    module_type == "kii" ? "kii_service" : "survey_service"
  );
  return response;
};

export const deleteSection = async (
  request,
  sectionId,
  module_type = "kii"
) => {
  const response = await request(
    "DELETE",
    `/v1/${module_type}/sections/${sectionId}`,
    {},
    module_type == "kii" ? "kii_service" : "survey_service"
  );
  return response;
};

export const getSectionList = async (
  request,
  questionnaireMetaId,
  module_type = "kii"
) => {
  const response = await request(
    "GET",
    `/v1/${module_type}/sections/${questionnaireMetaId}`,
    {},
    module_type == "kii" ? "kii_service" : "survey_service"
  );
  return response;
};

export const getSectionQuestion = async (
  request,
  selectedSection,
  module_type = "kii"
) => {
  const response = await request(
    "GET",
    `/v1/${module_type}/sections/questions/${selectedSection}`,
    {},
    module_type == "kii" ? "kii_service" : "survey_service"
  );

  return response;
};

export const getQuestionTypes = async (request, module_type = "kii") => {
  const response = await request(
    "GET",
    `/v1/${module_type}/questions/type`,
    {},
    module_type == "kii" ? "kii_service" : "survey_service"
  );

  return response;
};

export const getQuestionnaireData = async (
  request,
  questionnaireMetaId,
  module_type = "kii"
) => {
  const response =
    questionnaireMetaId &&
    module_type ?
    (await request(
      "GET",
      `/v1/${module_type}/questionnaires/questions/${questionnaireMetaId}`,
      {},
      module_type == "kii" ? "kii_service" : "survey_service"
    )) :[]

  return response;
};

export const markComplete = async (request, payload, module_type = "kii") => {
  const response = await request(
    "POST",
    `/v1/${module_type}/questionnaires/finalize`,
    {
      data: payload,
    },
    module_type == "kii" ? "kii_service" : "survey_service"
  );
  return response;
};
